var c1 = "/static/fba329a7c812d875.png";

export { c1 as default };
//# sourceMappingURL=c_1.png.js.map
